import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import {
  Helmet,
  flattenHTMLToAppURL,
  hasBlocksData,
  getBlocksFieldname,
  getBlocksLayoutFieldname,
  getBaseUrl,
} from '@plone/volto/helpers';
import { Container, Grid, Icon } from 'semantic-ui-react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
//import { rrulestr } from 'rrule';
//import moment from 'moment';
import config from '@plone/volto/registry';
import { UniversalLink } from '@plone/volto/components';

import {
  ViewTitle,
  //EventWhen,
  //TypeLabel,
  RelatedItems,
  Ticket,
  GoogleMap,
} from '@package/components';

const messages = defineMessages({
  unknownBlock: {
    id: 'Unknown Block',
    defaultMessage: 'Unknown Block {block}',
  },
});

const VMEventView = ({ content, location }) => {
  const intl = useIntl();
  const blocksFieldname = getBlocksFieldname(content);
  const blocksLayoutFieldname = getBlocksLayoutFieldname(content);

  const showInfos =
    content.contact_phone ||
    content.contact_email ||
    (content.geolocation && Object.keys(content.geolocation).length > 0) ||
    content.event_url;

  // let rruleSet = null;

  // if (content.recurrence?.length > 0) {
  //   rruleSet = rrulestr(content.recurrence, {
  //     compatible: true, //If set to True, the parser will operate in RFC-compatible mode. Right now it means that unfold will be turned on, and if a DTSTART is found, it will be considered the first recurrence instance, as documented in the RFC.
  //     forceset: true,
  //   });
  // }

  return (
    <Container className="view-wrapper event-view">
      <Helmet title={content.title} />
      <article id="content">
        <Grid stackable relaxed="very">
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <header>
              {/* <TypeLabel type={content['@type']} /> */}
              <ViewTitle
                title={content.title}
                description={content.description}
                url={location?.pathname}
                content={content}
              />
            </header>
            <div className="mobile-only">
              <Ticket content={content} />
            </div>
            {/*
            //nascosto come richiesto qui: https://redturtle.tpondemand.com/entity/13126-cancellare-riga-data-da-scheda-eventi
            <div className="event-date">
              <EventWhen
                start={content.start}
                end={content.end}
                whole_day={content.whole_day}
                open_end={content.open_end}
                recurrence={content.recurrence}
              />
            </div> */}
            <section id="content-core">
              {hasBlocksData(content)
                ? map(content[blocksLayoutFieldname].items, (block) => {
                    const blockType =
                      content[blocksFieldname]?.[block]?.['@type'];
                    if (['title', 'pageDescription'].indexOf(blockType) > -1)
                      return null;

                    const Block =
                      config.blocks?.blocksConfig[blockType]?.['view'] ?? null;
                    return Block !== null ? (
                      <Block
                        key={block}
                        id={block}
                        properties={content}
                        data={content[blocksFieldname][block]}
                        path={getBaseUrl(location?.pathname || '')}
                      />
                    ) : (
                      <div key={block}>
                        {intl.formatMessage(messages.unknownBlock, {
                          block: content[blocksFieldname]?.[block]?.['@type'],
                        })}
                      </div>
                    );
                  })
                : content.text?.data && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: flattenHTMLToAppURL(content.text.data),
                      }}
                    />
                  )}
            </section>

            {showInfos && (
              <section className="content-info">
                {(content.contact_phone ||
                  content.contact_email ||
                  (content.geolocation &&
                    Object.keys(content.geolocation).length > 0) ||
                  content.event_url) && (
                  <>
                    <FormattedMessage
                      id="eventInfoHeader"
                      defaultMessage="Informazioni di contatto"
                    >
                      {(message) => <h2 className="info-header">{message}</h2>}
                    </FormattedMessage>

                    {(content.contact_phone?.length > 0 ||
                      content.contact_email?.length > 0 ||
                      content.event_url?.length > 0) && (
                      <Grid className="info-links">
                        {content.contact_phone?.length > 0 && (
                          <Grid.Row>
                            <Grid.Column>
                              <UniversalLink
                                href={`tel:${content.contact_phone}`}
                              >
                                <Icon name="phone" />
                                &nbsp;
                                <span className="info-text">
                                  {content.contact_phone}
                                </span>
                              </UniversalLink>
                            </Grid.Column>
                          </Grid.Row>
                        )}

                        {content.contact_email?.length > 0 && (
                          <Grid.Row>
                            <Grid.Column mobile={12} tablet={12} computer={12}>
                              <UniversalLink
                                href={`mailto:${content.contact_email}`}
                              >
                                <Icon name="envelope" />
                                {content.contact_name ? (
                                  <span className="info-text">
                                    {content.contact_name}{' '}
                                    <small className="info-text-mail">
                                      ({content.contact_email})
                                    </small>
                                  </span>
                                ) : (
                                  <span className="info-text info-text-mail">
                                    {content.contact_email}
                                  </span>
                                )}
                              </UniversalLink>
                            </Grid.Column>
                          </Grid.Row>
                        )}

                        {content.event_url?.length > 0 && (
                          <Grid.Row>
                            <Grid.Column mobile={12} tablet={12} computer={12}>
                              <UniversalLink
                                href={content.event_url}
                                rel="noopener noreferrer"
                                target="_blank"
                              >
                                <Icon name="world" />
                                <FormattedMessage
                                  id="eventInfoWeb"
                                  defaultMessage="Visita il sito"
                                >
                                  {(message) => (
                                    <span className="info-text">{message}</span>
                                  )}
                                </FormattedMessage>
                                &nbsp;›
                              </UniversalLink>
                            </Grid.Column>
                          </Grid.Row>
                        )}
                      </Grid>
                    )}

                    {content.geolocation &&
                      Object.keys(content.geolocation).length > 0 && (
                        <div className="map-wrapper">
                          <GoogleMap
                            venues={[
                              {
                                lat: parseFloat(content.geolocation.lat),
                                lng: parseFloat(content.geolocation.lng),
                                title: content.title,
                                price: content.prices?.length
                                  ? content.prices[0]
                                  : null,
                              },
                            ]}
                            showPopup={false}
                          />
                        </div>
                      )}
                  </>
                )}
              </section>
            )}
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={4}>
            <aside className="right-column">
              <Ticket content={content} />

              {(content.location ||
                content.timetable ||
                content.audience ||
                content.prices?.length > 0 ||
                content.attendees?.length >
                  0) /*||
                rruleSet?.rdates()?.length > 0 ||
                 rruleSet?.exdates()?.length > 0*/ && (
                <section className="info-box event-info center">
                  {content.location && (
                    <>
                      <div className="info-box-header">
                        <FormattedMessage
                          id="eventInfoWhere"
                          defaultMessage="Dove"
                        >
                          {(message) => message}
                        </FormattedMessage>
                      </div>
                      <div className="info-box-text">{content.location}</div>
                    </>
                  )}

                  {/* {rruleSet && rruleSet.rdates().length > 0 && (
                    <>
                      <div className="info-box-header">
                        <FormattedMessage
                          id="more_dates"
                          defaultMessage="Date aggiuntive"
                        >
                          {(message) => message}
                        </FormattedMessage>
                      </div>
                      <div className="info-box-text">
                        {rruleSet.rdates().map((ex) => (
                          <div className="small">
                            {moment(ex).format('DD MMMM YYYY')}
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                  {rruleSet && rruleSet.exdates().length > 0 && (
                    <>
                      <div className="info-box-header">
                        <FormattedMessage
                          id="excluded_dates"
                          defaultMessage="L'evento non si terrà nelle seguenti date"
                        >
                          {(message) => message}
                        </FormattedMessage>
                      </div>
                      <div className="info-box-text">
                        {rruleSet.exdates().map((ex) => (
                          <div className="small">
                            {moment(ex).format('DD MMMM YYYY')}
                          </div>
                        ))}
                      </div>
                    </>
                  )} */}

                  {content.timetable && (
                    <>
                      <div className="info-box-header">
                        <FormattedMessage
                          id="eventInfoTime"
                          defaultMessage="Quando"
                        >
                          {(message) => message}
                        </FormattedMessage>
                      </div>
                      <div
                        className="info-box-text"
                        dangerouslySetInnerHTML={{
                          __html: flattenHTMLToAppURL(content.timetable),
                        }}
                      />
                    </>
                  )}
                  {content.audience && (
                    <>
                      <div className="info-box-header">
                        <FormattedMessage
                          id="eventInfoWho"
                          defaultMessage="A chi è rivolto"
                        >
                          {(message) => message}
                        </FormattedMessage>
                      </div>
                      <div className="info-box-text">{content.audience}</div>
                    </>
                  )}
                  {content.prices?.length > 0 && (
                    <>
                      <div className="info-box-header">
                        <FormattedMessage
                          id="eventInfoPrice"
                          defaultMessage="Prezzo"
                        >
                          {(message) => message}
                        </FormattedMessage>
                      </div>
                      <div className="info-box-text">
                        {content.prices.map((price, idx) => (
                          <div key={idx}>{price}</div>
                        ))}
                      </div>
                    </>
                  )}
                  {content.attendees?.length > 0 && (
                    <>
                      <div className="info-box-header">
                        <FormattedMessage
                          id="eventInfoAttendees"
                          defaultMessage="Partecipanti"
                        >
                          {(message) => message}
                        </FormattedMessage>
                      </div>
                      <div className="info-box-text">
                        {content.attendees.map((att) => (
                          <div key={att}>{att}</div>
                        ))}
                      </div>
                    </>
                  )}
                </section>
              )}
            </aside>
          </Grid.Column>
        </Grid>
        {content.related_experiences?.length > 0 && (
          <FormattedMessage
            id="eventRelatedHeader"
            defaultMessage="Esperienze correlate all'evento"
          >
            {(message) => (
              <RelatedItems
                items={content.related_experiences}
                title={message}
              />
            )}
          </FormattedMessage>
        )}
        {content.relatedItems?.length > 0 && (
          <FormattedMessage
            id="ti_potrebbe_interessare_anche"
            defaultMessage="Ti potrebbe interessare anche..."
          >
            {(message) => (
              <RelatedItems items={content.relatedItems} title={message} />
            )}
          </FormattedMessage>
        )}
      </article>
    </Container>
  );
};

VMEventView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        url: PropTypes.string,
        image: PropTypes.object,
        image_caption: PropTypes.string,
        '@type': PropTypes.string,
      }),
    ),
  }).isRequired,
};

export default VMEventView;
